<template>
    <div class="table-kanban-view">
        <!-- Dropdown alan yoksa empty state göster -->
        <div v-if="dropdownFields.length === 0" class="kanban-empty-state">
            <a-empty>
                <template #description>
                    <div class="empty-state-content">
                        <h3>{{ $t('tables.kanbanNotAvailable') }}</h3>
                        <p>{{ $t('tables.needDropdownField') }}</p>
                        <a-button type="primary" @click="switchToTableView">{{ $t('tables.switchToTable') }}</a-button>
                    </div>
                </template>
            </a-empty>
        </div>

        <!-- Dropdown alan varsa normal kanban görünümünü göster -->
        <template v-else>
            <KanbanToolbar
                :fields="dropdownFields"
                :selectedField="$_.get(kanbanSettings, 'kanbanField')"
                @change-field="onChangeField"
                @open-settings="overlayVisible = true"
                :records="records"
                :kanbanField="getKanbanFieldAsObject()"
                :groupValue="groupValue"
                :kanbanSettings="kanbanSettings"
            />

            <KanbanBoard
                :records="records"
                :kanbanSettings="kanbanSettings"
                :table="table"
                @update-record="updateRecord"
                :selectedRecords="selectedRecords"
                :isSelectionModeActive="isSelectionModeActive"
                @toggle-selection="$emit('toggle-selection', $event)"
                :getRecordColor="getRecordColor"
                :groupValue="groupValue"
            />

            <KanbanSettingsOverlay
                v-if="overlayVisible"
                :fields="table.fields"
                :kanbanSettings="kanbanSettings"
                @close="overlayVisible = false"
                @saveSettings="saveKanbanSettings"
            />
        </template>
    </div>
</template>

<script>
import Vue from "vue";
import KanbanToolbar from "./KanbanToolbar.vue";
import KanbanBoard from "./KanbanBoard.vue";
import KanbanSettingsOverlay from "./KanbanSettingsOverlay.vue";
import { TABLE_API } from "../../../../../api/table";
export default Vue.extend({
    name: "TableKanbanView",
    components: {
        KanbanToolbar,
        KanbanBoard,
        KanbanSettingsOverlay,
    },
    props: {
        /**
         * TableDetail.vue içerisinden
         * records ve tableFields props olarak gelebilir
         * tableId de isteğe bağlı
         */
        records: {
            type: Array,
            default: function () {
                return [];
            },
        },
        table: {
            type: Object,
            required: true,
        },
        selectedRecords: {
            type: Array,
            default: () => [],
        },
        isSelectionModeActive: {
            type: Boolean,
            default: false,
        },
        getRecordColor: {
            type: Function,
            required: true,
        },
        groupValue: {
            type: Object,
        },
    },
    data: function () {
        return {
            overlayVisible: false,
            kanbanSettings: {
                /**
                 * Kanban Board'da hangi alana göre kolon oluşturulacak
                 */
                kanbanField: null,

                /**
                 * Kanban Kartlarında hangi alanların görüneceği
                 */
                cardFields: [],
            },
        };
    },
    computed: {
        /**
         * Sadece fieldType "dropdown" ve options.mode "static" olan
         * alanları filtreliyoruz (sütun oluşturmak için)
         */
        dropdownFields: function () {
            var self = this;
            return self.table.fields.filter(function (f) {
                if (f.fieldType === "dropdown" && f.options && f.options.dropdown.mode === "static") {
                    return true;
                }
                return false;
            });
        },
    },
    created: function () {
        this.loadKanbanSettings();

        // Eğer localStorage'da kayıtlı bir ayar yoksa
        // ve geçerli dropdownFields arasında en az bir alan varsa
        // varsayılan olarak ilk alanı seçiyoruz
        if (!this.kanbanSettings.kanbanField && this.dropdownFields.length > 0) {
            this.kanbanSettings.kanbanField = this.dropdownFields[0]?._id;
        }
        //Eğer card fields boş ise en az 3 tane alan seç
        if (this.kanbanSettings.cardFields.length === 0) {
            this.kanbanSettings.cardFields = this.table.fields.slice(0, 3).map((f) => f._id);
        }
        this.kanbanSettings = this.$_.cloneDeep(this.kanbanSettings);
        this.saveKanbanSettings(this.kanbanSettings);
    },
    methods: {
        getKanbanFieldAsObject() {
            return this.table.fields.find((f) => f._id === this.kanbanSettings.kanbanField);
        },
        /**
         * Kanban alanı değiştiğinde ayarları kaydet
         */
        onChangeField: function (newFieldId) {
            this.kanbanSettings.kanbanField = newFieldId;
            this.saveKanbanSettings(this.kanbanSettings);
        },

        /**
         * LocalStorage'dan kanban ayarlarını yükleme
         */
        loadKanbanSettings: function () {
            var key = "kanban_settings_" + (this.table._id || "global");
            var saved = window.localStorage.getItem(key);
            if (saved) {
                try {
                    this.kanbanSettings = JSON.parse(saved);
                } catch (error) {
                    console.error("Kanban ayarları yüklenemedi:", error);
                }
            }
        },

        /**
         * Kanban ayarlarını localStorage'a kaydet
         */
        saveKanbanSettings: function (newSettings) {
            this.kanbanSettings = newSettings;
            var key = "kanban_settings_" + (this.table._id || "global");
            window.localStorage.setItem(key, JSON.stringify(this.kanbanSettings));
        },
        async updateRecord({ recordId, fieldId, value }) {
            const updatingFields = {
                [fieldId]: value,
            };
            console.log("updatingFields", {
                recordId,
                fieldId,
                value,
                updatingFields,
            });
            TABLE_API.updateRecord(this.table._id, recordId, updatingFields)
                .then((record) => {
                    this.$emit("record-updated", record);
                    this.$message.success(this.$t("tables.recordUpdatedSucs"));
                })
                .catch(() => {
                    this.$message.error(this.$t("tables.failedToUpdateRecord"));
                });
        },
        switchToTableView() {
            this.$emit("board-view-changed", "table");
        },
    },
});
</script>

<style scoped lang="scss">
.table-kanban-view {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
}

.kanban-empty-state {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2rem;

    .empty-state-content {
        text-align: center;

        h3 {
            font-size: 1.5rem;
            margin-bottom: 1rem;
            color: #1a1a1a;
        }

        p {
            color: #666;
            margin-bottom: 2rem;
            max-width: 500px;
            line-height: 1.5;
        }
    }

    :deep(.ant-empty-image) {
        height: 200px;
        margin-bottom: 2rem;
    }
}
</style>
